<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CommonSelect',
})
</script>
<template>
  <Select
    placeholder="请选择"
    :class="bem('select')"
    :loading="loading"
    optionLabelProp="label"
    showSearch
    optionFilterProp="label"
    @dropdownVisibleChange="onSelectOpen"
    v-bind="$attrs"
  >
    <Select.Option v-for="item in options" :key="item.value" :label="item.label">
      <slot name="option" v-bind="{ record: item }">
        {{ item.label }}
      </slot>
    </Select.Option>
    <template #dropdownRender="{ menuNode: menu }">
      <div :class="bem('operator')" v-if="operatorVisible">
        <Button v-if="createLink && $permission(createPermission)" size="small" type="link" :href="createLink" target="_blank">
          <template #icon> <PlusOutlined /></template>
          前去创建
        </Button>
        <Button type="link" @click="refresh" size="small" @mousedown="e => e.preventDefault()">
          <template #icon><ReloadOutlined /></template>
          刷新
        </Button>
      </div>
      <VNodes :vnodes="menu" />
    </template>
  </Select>
</template>

<script lang="ts" setup name="CommonSelect">
import { ReloadOutlined, PlusOutlined } from '@ant-design/icons-vue'
import { Select, Button } from 'ant-design-vue'
import { createNamespace } from '@bd/vue3-utils'
import { useAttrs } from 'vue'
import { VNodes } from '-/Common/VNodes'
import { useApi, type DefaultOptionItem } from '-/Common/useApi'
import { selectProps } from './props'
const [_, bem] = createNamespace('CommonSelect')
const props = defineProps(selectProps)
const attrs = useAttrs()
const emits = defineEmits<{
  (event: 'refresh'): void
  (event: 'optionsChange', options: DefaultOptionItem[]): void
}>()
const { options, getOptions, loading, refresh, isFirstLoad } = useApi(props, attrs, emits)
if (props.immediate && !props.alwaysRefresh) getOptions()
const onSelectOpen = vis => {
  if (!vis) return
  if (props.alwaysRefresh) {
    getOptions()
    return
  }
  if (!props.immediate && isFirstLoad.value) {
    getOptions()
  }
}
defineExpose({
  getOptions,
  options
})
</script>

<style lang="less">
.common-select {
  &__operator {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 12px;
    border-bottom: @border-base;
  }
}
</style>
